import { render, staticRenderFns } from "./LobbyRightMenuTabContent.vue?vue&type=template&id=3227765c&scoped=true"
import script from "./LobbyRightMenuTabContent.vue?vue&type=script&lang=js"
export * from "./LobbyRightMenuTabContent.vue?vue&type=script&lang=js"
import style0 from "./LobbyRightMenuTabContent.vue?vue&type=style&index=0&id=3227765c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3227765c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3227765c')) {
      api.createRecord('3227765c', component.options)
    } else {
      api.reload('3227765c', component.options)
    }
    module.hot.accept("./LobbyRightMenuTabContent.vue?vue&type=template&id=3227765c&scoped=true", function () {
      api.rerender('3227765c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Lobby/LobbyRightMenuTabContent.vue"
export default component.exports